<template>
	<div class="banner-suits card-body">
		<img class="banner-suits-top-image" src="https://storage.yandexcloud.net/proektoria-education/static/images/banner-suits-top.svg" alt="">

		<div class="banner-suits-body">
			<h2 class="h2-title">Вызов «{{data.title}}» подходит тебе на <span class="text-accent-success">{{data.mark * 10}}%</span></h2>
			<h3 class="banner-suits-info">
				В этом вызове ты продолжишь участие в конкурсе.<br>
				<span style="color: var(--black-60)">Изменить его можно до 25 июня.</span>
			</h3>
			<div class="banner-suits-description" v-html="data.description">

			</div>
		</div>

		<a :href="`https://edu.proektoria.online/dashboard/challenges/${data.id}`" class="link-underscore">Образовательный трек</a>
	</div>
</template>
<style lang="css">
	.banner-suits-top-image {
		position: absolute;
		top: 32px;
		right: 32px;
	}
	.text-accent-success {
		color: var(--success);
	}

	.banner-suits {
		position: relative;
		background-image: url("https://storage.yandexcloud.net/proektoria-education/static/images/suits-bottom.svg");
		background-repeat: no-repeat;
		background-position: bottom;
	}

	.banner-suits:after {
		content: '';
		display: block;
		position: absolute;
		right: 0;
		bottom: 0;
		width: 208px;
		height: 217px;
		background: url("https://storage.yandexcloud.net/proektoria-education/static/images/suits-person.png") no-repeat;
		background-size: 100%;
	}

	.banner-suits-description {
		font-size: 14px;
		line-height: 18px;
		color: var(--black-80);
	}
	.banner-suits-body {
		min-height: 90px;
		padding-right: 200px;
		margin-bottom: 32px;
		color: var(--black-90);
	}

	.banner-suits-info {
		font-weight: bold;
		font-size: 16px;
		line-height: 20px;
		margin-bottom: 12px;
	}

	@media (max-width: 768px) {
		.banner-suits-top-image {
			display: none;
		}
		.banner-suits-body {
			padding-right: 0;
			padding-bottom: 220px;
		}
	}
</style>
<script>
	export default {
		props: {
			data: {
				type: Object,
				default: () => {
					return {}
				},
				required: true,
			},
		}
	}
</script>
